import { type MarketingProduct } from '@he-novation/config/types/subscription.types';

interface WorkspaceSubscriptionTypeProps {
    product: MarketingProduct;
}

export function WorkspaceSubscriptionProduct({ product }: WorkspaceSubscriptionTypeProps) {
    return (
        <>
            <h2 className="text-text-focus mb-4 text-3xl font-bold ">{product.name}</h2>
            <span className="text-primary mb-2.5 block font-bold uppercase">
                {product.description}
            </span>
        </>
    );
}
